import tryLift from '@/public/images/image-enhancement/tryLift.webp';

export const tryLiftConfig = {
	data: {
		title1: 'tryLiftData_title1',
		title2: 'tryLiftData_title2',
		accentText: 'tryLiftData_greenText',
		description: 'tryLiftData_subtitle',
	},
	images: [
		{
			image: tryLift,
			title: 'tryLiftData_imageTitle',
			alt: 'tryLiftData_imageAlt',
		},
	],
};
